module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	require('../flashplayer2')(fox);
	require('./mobileFormatSwitcher')(fox);
	
	fox.registerWidget('Content_FlashPlayer', {
		configure: function (options) {
			this.MOBILE_DEVICES_START_FORMAT = 'ipod';

			this.registerOptions('', {
				getMapMethod: 'site.format.getMap',
				jsonizeMapRequest: true,
				resourceIdParamName: 'contentId',
				'handleWom.recieveContentId': {
					widget: '@this',
					event: 'setContentId',
					callback: 'recieveContentId'
				}
			});

			this.mode = 'format';
			this.callParent('configure', arguments);
		},

		init: function () {
			this.callParent('init', arguments);

			if (fox.utils.isTouchDevice()) {
				this.embedMobileFormatSwitcher();
			}
		},

		recieveContentId: function (id) {
			this.formatGetMap(id);
		},

		getMapApi: function () {
			var
				api = this.wom1('#mapApi');

			if (!api) {
				api = this.embedWidget('mapApi', 'Api', {
					method: this.getOption('getMapMethod')
				});

				api.run();
			}

			return api;
		},

		formatGetMap: function(id, resCallback, callbackParams) {
			var
				api = this.getMapApi(),
				resIdParamName = this.getOption('resourceIdParamName'),
				apiParams = {mode: this.mode == 'preview' ? 'preview' : 'format'};

			this.setContentId(id);
			this.waitEvent(api, 'success', resCallback || 'formatGetMapApiSuccessHandler', callbackParams || {});

			apiParams[resIdParamName] = this.getContentId();
			api.send(apiParams, this.getOption('jsonizeMapRequest'));
		},

		formatGetMapApiSuccessHandler: function(data) {
			this.preparePlayerData(data.answer.response);
		},

		preparePlayerData: function (map) {
			this.setFormatMap(map).changeFormat(this.getStartFormat());
		},

		getStartFormat: function () {
			if(fox.getEnv('siteProps.settingId')){
			    fox.each(this.getFormatMap().download, function(val) {
			        val.link = val.link + (val.link.indexOf('?') == -1 ? '?' : '%26') + 'settingId=' + fox.getEnv('siteProps.settingId');
			    }, this);
			}

			var format, height = 0;

			if (fox.utils.isTouchDevice() && this.getFormatMap().view[this.MOBILE_DEVICES_START_FORMAT]) {
				return this.setVideoFormat(this.MOBILE_DEVICES_START_FORMAT);
			}

			fox.each(this.getFormatMap().view, function(val, name) {
				var fh = Number(val.height);
				if (!format || (height < fh)) {
					height = fh;
					format = name;
				}
			}, this);
			return this.setVideoFormat(format);
		},

		buildBitrates: function() {
			var bitrates = [];

			fox.each(this.getFormatMap().view, function(val, name) {
				if (val.roles && !fox.inArray(val.roles, this.mode)) {
					return; // means 'continue'
				}
				var clip = 'http://' + this.window.location.host + val.link;
				if (this.getOption('useHash')){
					if (clip.indexOf('publisher_auth=') == -1) {
						clip = clip + (clip.indexOf('?') == -1 ? '?' : '%26') + 'publisher_auth=' + fox.getEnv('siteProps.publisher_auth');
					}
				}
				if(fox.getEnv('siteProps.settingId')){
                    clip = clip + (clip.indexOf('?') == -1 ? '?' : '%26') + 'settingId=' + fox.getEnv('siteProps.settingId');
                }
				var template = {
					'value': val.height + 'p.',
					'isHD': val.hd == 1,
					'onSelect': 'changeFormat1',
					'onSelectArguments': name
				};

				if (this.getOption('dontReloadPlayerOnChangeFormat')) {
					template.onSelect = null;
					template.onSelectArguments = {
						clip: {
							url: clip,
							autoPlay: true,
							provider: 'httpstreaming',
							scale: 'orig'
						}
					};
				}

				if (name === this.getVideoFormat()) {
					template.isActive = true;
				}

				bitrates.push(template);
			}, this);

			this.setBitrates(bitrates);
			return this;
		},

		//only mc-admin feature
		switchMode: function(mode) {
			this.mode = mode == 'preview' ? 'preview' : 'format';
			this.buildBitrates();
			var map = this.getFormatMap().view;
			var bitrates = this.getBitrates();

			switch (this.mode) {
				case 'preview':
					fox.each(map, function(format) {
						format.link = format.link + '/preview';
					});

					fox.each(bitrates, function(item) {
						item.onSelectArguments.clip.url = item.onSelectArguments.clip.url + '/preview';
					});
				break;

				default:
					fox.each(map, function(format) {
						format.link = format.link.replace('\/preview', '');
					});

					fox.each(bitrates, function(item) {
						item.onSelectArguments.clip.url = item.onSelectArguments.clip.url.replace('\/preview', '');
					});
				break;
			}

			return this;
		},

		embedMobileFormatSwitcher: function () {
			this.setOption('widgets.mobileFormatSwitcher', fox.mergeRecursive({
				widget: 'Content_FlashPlayer_MobileFormatSwitcher'
			}, this.getOption('mobileSwitcher')));
		}

	}, 'FlashPlayer2');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/content/flashplayer.js
// module id = 444
// module chunks = 4